export const experienceData = [
  {
    id: 1,
    company: 'AlgoScript Software Pvt. Ltd.',
    jobtitle: 'React Developer',
    startYear: '2020',
    endYear: '2022',
  },
  {
    id: 2,
    company: 'Tecocraft Infusion Pvt. Ltd.',
    jobtitle: 'React Developer',
    startYear: '2022',
    endYear: '2023',
  },
  {
    id: 3,
    company: 'STAAH',
    jobtitle: 'React Developer',
    startYear: '2023',
    endYear: 'Present',
  },
];
